import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BasePageComponent } from '../../base-page';
import { IMoney } from '../../../model/money.model';
import { Subject } from 'rxjs';
import { FormService } from '../../../shared/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { MoniesService } from '../monies/monies.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import { ConstantMonies } from '../monies/monies.url';
import { ConstantHome } from '../home/home.url';
import { Url } from '../../../shared/constant/url.constant';
import { takeUntil } from 'rxjs/operators';
import { CONSTANT_ICON } from '../../../shared/constant/icon.constant';
import { MoniesAddComponent } from '../monies/add/monies-add.component';
import { MoniesShowComponent } from '../monies/show/monies-show.component';
import { MoniesUpdateComponent } from '../monies/update/monies-update.component';
import { MoneyDeleteComponent } from '../monies/delete/monies-delete.component';
import { IServiceItem, ServiceItemStatus } from '../../../model/service-item.model';
import { ServiceItemService } from './service-item.service';
import { ConstantServiceItems } from './service-items.url';
import { ServiceItemAddComponent } from './add/service-item-add.component';
import { IAccountRessType } from '../../../model/acc_ress_type.model';
import { AccountService } from '../../../services/ServiceEntity/account.service';
import { TranslateService } from '@ngx-translate/core';
import { BTN_CANCEL_CLASS, CANCEL_BG_COLOR, WIDTH_MEDIUM_POPUP_CLASS } from '../../../shared/constant/css-style/css-class.constant';
import { ColorService } from '../../../shared/services/color.service';
import { BaseService } from '../base/base.service';
import { Domain } from '../../../model/domain.model';
import { DomainAffectStatusComponent } from '../domain/affect_status/domain-affect-status.component';
import { ServiceItemUpdateComponent } from './update/service-item-update.component';
import { ServiceItemDeleteComponent } from './delete/service-item-delete.component';
import { ChampsFormulaireAddComponent } from '../champs_formulaires/champs_formulaires/add/champs-formulaire-add.component';
import { FormulaireLinkComponent } from '../formulaires/formulaire-link/formulaire-link.component';
import { SIZE_H_MD_POPUP, SIZE_W_MD_POPUP } from '../../../shared/constant/css-style/css-size.constant';

@Component({
  selector: 'app-service-items',
  templateUrl: './service-items.component.html'
})
export class ServiceItemsComponent extends BasePageComponent implements OnInit,
  OnDestroy {

  @ViewChild('basicTable') tabRef: any;
  serviceItemList: ServiceItemStatus[];
  serviceItemSearch: ServiceItemStatus[];
  searchValue: string;
  subs$ = new Subject<void>();

  constructor(
    public baseService: BaseService,
    private colorService: ColorService,
    private accountService: AccountService,
    private formService: FormService,
    private dialog: MatDialog,
    private serviceItemService: ServiceItemService,
    store: Store<IAppState>, httpSv: HttpService,
    private translate: TranslateService) {
    super(store, httpSv);
    console.log('## construct service item list');
    this.pageData = {
      title: ConstantServiceItems.data.sub.list.title,
      key: 'listServiceItems',
      // fil d'ariane.
      breadcrumbs: [
        {
          title: '',
          key: 'home',
          route: Url.SLASH_ROUTE.concat(ConstantHome.data.routing)
        },
        {
          title:'',
          key: 'service',
          route: Url.SLASH_ROUTE.concat(ConstantServiceItems.urlFull
            .SERVICE_ITEMS.LIST)
        },
        {
          title: '',
          key: 'lister',
        }
      ]
    };

    if(this.pageData.key==="listServiceItems"){
      translate.get('listServiceItems').subscribe(res => this.pageData.title=res);
    }
    this.pageData.breadcrumbs.forEach(value=> {
      if(value.key==="home"){
        translate.get('home').subscribe(res => value.title=res);
      }
      if( value.key==="service" ){
        translate.get('service').subscribe(res => value.title=res);
      }
      if( value.key==="lister" ){
        translate.get('lister').subscribe(res => value.title=res);
      }
     
     
    }); 
  }

  ngOnInit(): void {
    console.log('## init service items liste');
    super.ngOnInit();
    this.accountService.identity(false).pipe(takeUntil(this.subs$))
      .subscribe(account => {
        this.serviceItemService.queryStatus().subscribe(res => {
          console.log('## Success get service item list');
          this.serviceItemList = (res.body) ? res.body : [];
          console.log('## size: ' + this.serviceItemList.length);
          this.serviceItemSearch = this.serviceItemList;
          super.setLoaded();
          console.log('## BEFORE get list service in list by subject', this.serviceItemList);
          this.serviceItemService.getServiceItemObs().pipe(takeUntil(this.subs$))
            .subscribe((res: ServiceItemStatus[]) => {
              console.log('## get list service in list by subject', res);
              this.serviceItemList = (res) ? res : [];
              this.serviceItemSearch = this.serviceItemList;
            });
        });
      });
  }

  ngOnDestroy() {
    console.log('## on destroy service item list');
    super.ngOnDestroy();
    this.formService.free(this.subs$);
  }

  link() {
    console.log('## open formulaire link');
    this.dialog.open(FormulaireLinkComponent, {
      height: SIZE_H_MD_POPUP,
      width: SIZE_W_MD_POPUP
    });
  }

  addForm() {
    console.log('## open formulaire add');
    this.baseService.open(this.dialog, ChampsFormulaireAddComponent);
  }

  getStatusBg(id: number): string {
    return this.colorService.getStatusBg(id);
  }

  getTheadBg() {
    return this.colorService.getTheadBg();
  }

  getBgSearchBar() {
    return this.colorService.getBrdColorSearchBar();
  }

  getColorSearchBar() {
    return this.colorService.getColorSearchBar();
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getCancelBgColor(): string {
    return CANCEL_BG_COLOR;
  }

  getBtnCancelClass(): string {
    return BTN_CANCEL_CLASS;
  }

  search(): void {
    const query = this.searchValue;
    console.log('## search: ' + query);
    const mapFn = (item) =>
      Object.values(item)
        .map(function(val) {
          return val?.toString().toLowerCase();
        })
        .join(' ');
    const stringArr = [...this.serviceItemSearch].map(mapFn);
    const result = this.serviceItemSearch.filter(
      (_, i) => stringArr[i].indexOf(query && query.length ? query.toLowerCase() : '') > -1
    );
    this.serviceItemList = [];
    result.forEach((c) => {
      this.serviceItemList.push(c);
    });
  }

  getIcon() {
    return CONSTANT_ICON;
  }

  /**
   * Ouvre le template html AccountsRessourceTypeAddComponent
   * dans un popup.
   */
  add() {
    console.log('## open service item add');
    this.dialog.open(ServiceItemAddComponent, {
      height: '700px',
      width: '800px'
    });
  }

  show(c: IServiceItem) {
    /*console.log('## open service show');
    this.serviceItemService.setServiceItemSelectObs(c);
    this.dialog.open(MoniesShowComponent, {
      height: '700px',
      width: '800px',
    });*/
  }

  update(c: IServiceItem) {
    this.serviceItemService.setServiceItemSelectObs(c);
    this.dialog.open(ServiceItemUpdateComponent, {
      height: '700px',
      width: '800px',
    });
  }

  delete(c: IServiceItem) {
    this.serviceItemService.setServiceItemSelectObs(c);
    this.dialog.open(ServiceItemDeleteComponent, {
      height: '700px',
      width: '800px',
    });
  }

  /**
   * Retourne la liste des services items
   * qui ont été stockés dans le selector 'nz-table'.
   */
  getList(): ServiceItemStatus[] {
    return (this.tabRef) ? this.tabRef.data : [];
  }

}
